import { render, staticRenderFns } from "./CardsProductsLonas.vue?vue&type=template&id=638d6090&scoped=true&"
import script from "./CardsProductsLonas.vue?vue&type=script&lang=js&"
export * from "./CardsProductsLonas.vue?vue&type=script&lang=js&"
import style0 from "./CardsProductsLonas.vue?vue&type=style&index=0&id=638d6090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638d6090",
  null
  
)

export default component.exports